import { render } from "./SectionPaymentManagement.vue?vue&type=template&id=56110573&scoped=true"
import script from "./SectionPaymentManagement.vue?vue&type=script&lang=js"
export * from "./SectionPaymentManagement.vue?vue&type=script&lang=js"

import "./SectionPaymentManagement.vue?vue&type=style&index=0&id=56110573&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56110573"]])

export default __exports__